import { useQuery } from '@tanstack/react-query';
import { usePermissions } from '@/features/auth';
import { fetchSmriqCredential } from '../services/smriqCredentials';

export const smriqCredentialKeys = {
    all: ['smriq-credential'] as const,
    detail: (productId: string) => [...smriqCredentialKeys.all, productId] as const,
};

export const useSmriqCredentialQuery = (productId?: string) => {
    // Hooks run before render, so the panel's PermissionGuard cannot stop this fetch --
    // without the gate a caller lacking smr.product.read issues a request that 403s.
    const { hasPermission } = usePermissions();
    const canRead = hasPermission({ resource: 'smr', action: 'product.read' });

    return useQuery({
        queryKey: smriqCredentialKeys.detail(productId ?? ''),
        queryFn: () => fetchSmriqCredential(productId as string),
        enabled: Boolean(productId) && canRead,
    });
};
